import { useTranslation } from '@spcc/core'
import { Badge, Checkbox, cn } from '@spcc/uikit'
import type { SubCustomerType } from '../../domain/types'
import { SUB_CUSTOMER_TYPE } from '../../domain/constants'

export function isPlaceholderSubCustomer(type?: SubCustomerType | null): boolean {
  return type === SUB_CUSTOMER_TYPE.PLACEHOLDER
}

/** Amber "To be confirmed" badge; renders nothing for regular sub-customers */
export function SubCustomerTypeBadge({
  type,
  className,
}: {
  type?: SubCustomerType | null
  className?: string
}) {
  const { t } = useTranslation()
  if (!isPlaceholderSubCustomer(type)) return null
  return (
    <Badge
      variant="outline"
      className={cn('text-xs border-amber-400 text-amber-700 dark:text-amber-300', className)}
    >
      {t('subCustomers.typePlaceholder')}
    </Badge>
  )
}

/** Checkbox that flips a sub-customer between regular and placeholder */
export function SubCustomerTypeToggle({
  value,
  onChange,
}: {
  value: SubCustomerType
  onChange: (value: SubCustomerType) => void
}) {
  const { t } = useTranslation()
  return (
    <label className="flex items-start gap-2 cursor-pointer min-h-11">
      <Checkbox
        className="mt-0.5"
        checked={isPlaceholderSubCustomer(value)}
        onCheckedChange={(checked) =>
          onChange(checked === true ? SUB_CUSTOMER_TYPE.PLACEHOLDER : SUB_CUSTOMER_TYPE.REGULAR)
        }
      />
      <span className="flex flex-col">
        <span className="text-sm text-foreground">{t('subCustomers.typePlaceholder')}</span>
        <span className="text-xs text-muted-foreground">{t('subCustomers.typePlaceholderHint')}</span>
      </span>
    </label>
  )
}
